import type { StoryProgress } from '@/domain/story'
import type { StoryProgressRepository } from '@/repositories/StoryProgressRepository'

const STORAGE_KEY = 'cybertales.storyProgress'

function readAll(): StoryProgress[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as StoryProgress[]) : []
  } catch {
    return []
  }
}

function writeAll(items: StoryProgress[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch {
    // best-effort — story progress simply won't persist across reloads.
  }
}

export class LocalStoryProgressRepository implements StoryProgressRepository {
  async getProgress(userId: string, storyId: string): Promise<StoryProgress | null> {
    return readAll().find((p) => p.userId === userId && p.storyId === storyId) ?? null
  }

  async saveProgress(progress: StoryProgress): Promise<void> {
    const all = readAll()
    const idx = all.findIndex((p) => p.userId === progress.userId && p.storyId === progress.storyId)
    if (idx >= 0) all[idx] = progress
    else all.push(progress)
    writeAll(all)
  }

  async resetProgress(userId: string, storyId: string): Promise<void> {
    writeAll(readAll().filter((p) => !(p.userId === userId && p.storyId === storyId)))
  }
}
